export const DEFAULT_TEXTBOX_MAX_LENGTH = 255;
export const MAX_DELTA_YEARS = 125;
